/* EOD Home (Nov 2026): reusable photo slideshow. <eod-slides data-mode="fade|slide" data-speed="5"> with .eodh-slide children and .eodh-slides__dot buttons. */
if (!customElements.get('eod-slides')) {
  customElements.define('eod-slides', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.eodh-slide')];
      this.dots = [...this.querySelectorAll('.eodh-slides__dot')];
      this.i = 0;
      this.ms = Math.max(3, parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) return;
      this.dots.forEach((d, n) => d.addEventListener('click', (e) => { e.preventDefault(); this.go(n); this.restart(); }));
      this.visible = false;
      this.io = new IntersectionObserver((es) => { this.visible = es[0].isIntersecting; this.restart(); });
      this.io.observe(this);
      this.onVis = () => this.restart();
      document.addEventListener('visibilitychange', this.onVis);
      this.onSelect = (e) => {
        const n = this.slides.findIndex((s) => s.dataset.shopifyEditorBlock && s.dataset.shopifyEditorBlock.includes(e.detail.blockId));
        if (n > -1) { this.go(n); this.paused = true; this.restart(); }
      };
      this.onDeselect = () => { this.paused = false; this.restart(); };
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onDeselect);
    }
    disconnectedCallback() {
      clearInterval(this.t);
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onDeselect);
    }
    restart() {
      clearInterval(this.t);
      if (this.reduced || this.paused || !this.visible || document.hidden) return;
      this.t = setInterval(() => this.go((this.i + 1) % this.slides.length), this.ms);
    }
    go(n) {
      if (n === this.i) return;
      const prev = this.slides[this.i], next = this.slides[n];
      if (this.dataset.mode === 'slide') {
        next.style.transition = 'none';
        next.classList.remove('is-prev');
        void next.offsetWidth;
        next.style.transition = '';
        prev.classList.add('is-prev');
      }
      prev.classList.remove('is-active');
      next.classList.add('is-active');
      if (this.dots[this.i]) this.dots[this.i].classList.remove('is-active');
      if (this.dots[n]) this.dots[n].classList.add('is-active');
      this.i = n;
    }
  });
}